//export const API_URL_BASE = 'http://localhost:8080/Sales/v1_0';
//export const URL_BASE = 'http://localhost:3003';

export const API_URL_BASE = 'https://www.buydeal.eu/Sales/v1_0';
export const URL_BASE = 'https://tickets.buydeal.eu';